import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 rounded-md text-sm font-semibold transition focus:outline-none focus:ring-2 focus:ring-offset-2 text-center whitespace-normal break-words leading-snug min-w-0 disabled:opacity-50 disabled:cursor-not-allowed",
  {
    variants: {
      variant: {
        primary: "bg-primary text-primary-foreground hover:opacity-90 focus:ring-ring",
        secondary: "bg-secondary text-secondary-foreground border border-border hover:bg-kirusa-light focus:ring-ring",
        outline: "border border-border bg-transparent text-foreground hover:bg-secondary focus:ring-ring",
        ghost: "bg-transparent text-foreground hover:bg-secondary focus:ring-ring",
        destructive: "bg-destructive text-destructive-foreground hover:opacity-90 focus:ring-destructive",
        accent: "bg-accent text-accent-foreground hover:opacity-90 focus:ring-ring",
      },
      size: {
        sm: "h-8 px-3 text-xs",
        md: "h-10 px-4 py-2",
        lg: "h-11 px-6 text-base",
      },
    },
    defaultVariants: { variant: "primary", size: "md" },
  }
);

export type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> &
  VariantProps<typeof buttonVariants> & { asChild?: boolean };

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant, size, children, ...props }, ref) => {
    return (
      <button ref={ref} className={cn(buttonVariants({ variant, size }), className)} {...props}>
        {children}
      </button>
    );
  }
);
Button.displayName = "Button";
